@if (dialogConfig.config) {
  <div
    role="dialog"
    aria-modal="true"
    class="modal-wrapper"
    [attr.data-cy]="dialogConfig.dataCy"
    [style.backgroundColor]="dialogConfig.config.backgroundColor"
  >
    @if (dialogConfig.config.header) {
      <div
        class="modal-header"
        [style]="{
          backgroundColor: dialogConfig.config.header.backgroundColor,
          backgroundImage:
            dialogConfig.config.header.backgroundImage | transformUrl,
        }"
      >
        <div class="logo">
          @if (dialogConfig.config.header.logo) {
            <img
              class="brand-logo"
              [src]="dialogConfig.config.header.logo.imageUrl"
              [alt]="
                dialogConfig.config.header.logo.alternativeText
                  | replaceVars: nbSelections
              "
            />
          }
        </div>
      </div>
    }

    <div
      class="modal-content"
      [style.padding]="
        !!dialogConfig.config.title ? '1rem 2rem' : '2rem 1rem 1.5rem'
      "
    >
      @let nbSelections = dialogConfig.data || 0;

      @let title = dialogConfig.config.title;
      <p
        class="modal-title"
        [style]="{
          color: title.color,
          fontFamily: title.fontFamily,
        }"
        [innerHTML]="title.label | replaceVars: nbSelections | safe"
      ></p>
      @let body = dialogConfig.config.body;
      <p
        class="modal-body"
        [style]="{
          color: body.color,
          fontFamily: body.fontFamily,
        }"
        [innerHTML]="body.label | replaceVars: nbSelections | safe"
      ></p>

      <div class="modal-footer">
        <b2c-button
          class="close-btn"
          data-cy="close_btn"
          (click)="closeDialog()"
          [title]="closeButtonConfig.ariaLabel"
          [attr.aria-label]="closeButtonConfig.ariaLabel"
          [styles]="{
            color: closeButtonConfig.textColor,
            borderRadius: closeButtonConfig.borderRadius,
            fontFamily: closeButtonConfig.fontFamily,
            backgroundColor: closeButtonConfig.backgroundColor,
            borderColor:
              closeButtonConfig.borderColor ||
              closeButtonConfig.backgroundColor,
          }"
        >
          {{ closeButtonConfig.label }}</b2c-button
        >
      </div>
    </div>
  </div>
}
